import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminAllFixedPagesComponent from "../../Components/Admin/AdminAllFixedPages";
import SideBar from "../../Components/Admin/SideBar";

const AdminAllFixedPages = () => {
  return (
    <AdminAllFixedPagesComponent />
  );
};

export default AdminAllFixedPages;
